/**
 * Model to map Monitoring Elaboration Changes.
 *
 * @author mohit.khurana@vernuso.com
 */
export class Elaboration {
    description: String;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/elaboration.model.ts